import { forwardRef } from 'react';
import { AppBar, type AppBarProps } from '@lingoda/ui';
import { useHeaderContext } from '@lingoda/contexts';

interface Props extends Pick<AppBarProps, 'elevation' | 'children'> {
    id?: HTMLDivElement['id'];
}

export const BaseAppBar = forwardRef<HTMLDivElement, Props>(({ children, ...props }, ref) => {
    const { backgroundColor: headerBackgroundColor } = useHeaderContext();

    return (
        <AppBar
            position="static"
            component="div"
            elevation={0}
            {...props}
            ref={ref}
            sx={{ backgroundColor: headerBackgroundColor, borderRadius: 0 }}
        >
            {children}
        </AppBar>
    );
});

BaseAppBar.displayName = 'BaseAppBar';
